module.exports = __webpack_public_path__ + "static/media/NeutralCheckboxIcon.2bdf7bb1.svg";